/* eslint-disable no-empty-pattern */
import objectHash from 'object-hash'
import camundaAPI from '@/services/camunda'
import authAPI from '@/services/auth'
import devicePush from '@/services/device-push'

const state = {
  authenticating: false,
  profile: null,
  accessToken: null,
  authenticated: false,
  authMessage: null,
  keycloak: null,
  updateTokenInterval: null,
  groups: null,
  groupsHash: null,
  groupIds: null
}

const getters = {
  /* eslint-disable no-shadow */
  authenticating: state => state.authenticating,
  authenticated: state => state.authenticated,
  authMessage: state => state.authMessage,
  keycloak: state => state.keycloak,
  accessToken: state => state.accessToken,
  profile: state => state.profile,
  groups: state => state.groups,
  groupsHash: state => state.groupsHash,
  groupIds: state => state.groupIds,
}

const actions = {
  authenticate({ }, payload) {
    authAPI.authenticate(payload.to, payload.from, payload.next)
  },

  login({ }, payload) {
    authAPI.login(payload.username, payload.password)
  },

  checkGroupPermission({ state, dispatch }, payload) {
    const hasRole = state.groups.some(r => payload.to.meta.groups.indexOf(r.id) >= 0)
    if (hasRole) {
      payload.next()
    } else {
      dispatch('tools/setSnackbar', 'У Вас нет доступа на данную страницу', { root: true })
      payload.next('/home')
    }
  },

  getGroups({ commit, state }) {
    return camundaAPI.user
      .group({ member: state.profile.userName })
      .then((result) => {
        commit('set', { type: 'groups', value: result.data })
        commit('set', { type: 'groupsHash', value: objectHash(result.data) })
        return Promise.resolve()
      })
  },
  getGroupsByIds({ commit }, nameLike) {
    return camundaAPI.group
      .list(nameLike)
      .then((result) => {
        commit('set', { type: 'groupIds', value: result.data })
        return Promise.resolve()
      })
  },
  createGroup({}, payload) {
    return camundaAPI.group.create(payload);
  },
  createUser({}, payload) {
    return camundaAPI.user.create(payload);
  },
  createMember({}, payload) {
    return camundaAPI.group.createMember(payload.groupId, payload.userId);
  },
  deleteMember({}, payload) {
    return camundaAPI.group.deleteMember(payload.groupId, payload.userId);
  },
  getMembers({}, payload) {
    return camundaAPI.user.getMemberOf(payload.groupId);
  },
  getUserListById({}, payload) {
    return camundaAPI.user.list(payload.userId);
  },

  getWorkPlaceEmloyees({ commit }, workPlaceId) {
    return dataAPI.employee.workPlaceEmployees(workPlaceId).then((result) => {
      const workPlaceEmployees = result.data;
      commit('set', { type: 'workPlaceEmployees', value: workPlaceEmployees })
    })
  },

  // eslint-disable-next-line no-empty-pattern
  initializeUser({}, payload) {
    return camundaAPI.user
      .initialize(payload)
      .then(result => Promise.resolve(result))
      .catch(error => Promise.reject(error))
  },

  logout({ state, commit }) {
    commit('set', { type: 'authenticated', value: false })
    if (window.cordova !== undefined) {
      devicePush.unsubscribe(state.profile.userName) // Cordova push notifications
    }
    clearInterval(state.updateTokenInterval)
    state.keycloak.logout()
  },
}

const mutations = {
  set(state, { type, value }) {
    state[type] = value
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js